import React from 'react';
import { FadeIn } from './FadeIn';
import { XCircle } from 'lucide-react';
export function FailedAttempts() {
  const attempts = [{
    title: "Decirle 'Cálmate'",
    desc: 'Activa más ansiedad porque el adolescente siente que no entiendes la gravedad de lo que siente su cuerpo.'
  }, {
    title: 'Intentar razonar con lógica',
    desc: 'Es imposible porque la amígdala (el centro del miedo) ha bloqueado la parte racional del cerebro.'
  }, {
    title: 'Respirar profundo sin técnica',
    desc: 'Suele causar hiperventilación, lo que aumenta el mareo y el terror físico.'
  }, {
    title: 'Buscar síntomas en Google',
    desc: 'Solo confirma sus peores miedos, alimentando un segundo ataque de pánico.'
  }];
  return <section className="w-full bg-sage-light py-20 md:py-28 px-6" data-id="element-14">
      <div className="max-w-5xl mx-auto" data-id="element-15">
        <FadeIn data-id="element-16">
          <h2 className="text-3xl md:text-4xl font-serif text-slate-900 text-center mb-16" data-id="element-17">
            Lo Que Ya Intentaste <br className="md:hidden" data-id="element-18" />
            <span className="text-slate-600" data-id="element-19">(Y Por Qué No Funcionó)</span>
          </h2>
        </FadeIn>

        <div className="grid md:grid-cols-2 gap-6 md:gap-8" data-id="element-20">
          {attempts.map((item, index) => <FadeIn key={index} delay={0.1 * (index + 1)} data-id="element-21">
              <div className="bg-white p-8 rounded-2xl shadow-sm border border-sage/20 h-full flex flex-col transition-transform hover:-translate-y-1 duration-300" data-id="element-22">
                <div className="flex items-start gap-4" data-id="element-23">
                  <div className="flex-shrink-0 mt-1" data-id="element-24">
                    <XCircle className="w-8 h-8 text-amber" data-id="element-25" />
                  </div>
                  <div data-id="element-26">
                    <h3 className="text-xl font-bold text-slate-900 mb-3" data-id="element-27">
                      {item.title}
                    </h3>
                    <p className="text-slate-700 leading-relaxed" data-id="element-28">
                      {item.desc}
                    </p>
                  </div>
                </div>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}